<template>
  <div class="box">
    <Header title="用户中心"></Header>
    <div class="show-box">
      <div class="title-card"></div>
      <div class="header-info">
        <div class="header-info-box">
          <div class="header-info-detail">
            <div class="header-info-title">新增客户</div>
            <div class="header-info-unit">(当月数量)</div>
            <div class="header-info-content">
              <countTo
                :startVal="0"
                :endVal="this.memeberCreate ? Number(this.memeberCreate) : 0"
                :duration="2000"
                separator
              ></countTo>
            </div>
          </div>
          <div class="header-info-detail">
            <div class="header-info-title">下单客户</div>
            <div class="header-info-unit">(当月数量)</div>
            <div class="header-info-content">
              <countTo
                :startVal="0"
                :endVal="this.memberBuy ? Number(this.memberBuy) : 0"
                :duration="2000"
                separator
              ></countTo>
            </div>
          </div>
          <div class="header-info-detail" style="border-right: unset">
            <div class="header-info-title">用户总数</div>
            <div style="height: 26px"></div>
            <div class="header-info-content">
              <countTo
                :startVal="0"
                :endVal="this.memberTotal ? Number(this.memberTotal) : 0"
                :duration="2300"
                separator
              ></countTo>
            </div>
          </div>
        </div>
        <div class="header-date-box">
          <div class="container">
            <div class="re-box">
              <div class="re-item">
                <div class="re-item-front">
                  <img src="../assets/images/user-Header.png" alt />
                </div>
                <div class="re-item-back">
                  <img src="../assets/images/user-Header.png" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="orderCsh-box">
        <div class="userTypeBox">
          <div v-if="!showPersonalFlg" class="userTypeChoose">不含个人用户</div>
          <div v-else class="userTypeChoose">含个人用户</div>
          <van-switch
            v-model="showPersonalFlg"
            size="14"
            active-color="#da291c"
            inactive-color="#dcdee0"
            @change="userTypeSelect()"
          />
        </div>
        <van-field
          class="csh-box"
          v-model="orderCsh"
          :readonly="true"
          input-align="center"
          right-icon="wap-nav"
          placeholder="请选择区域"
          @click="searchCsh()"
        />
      </div>
      <div class="echart-box">
        <div class="user-chart" ref="userChart1"></div>
      </div>

      <div class="user-search-box">
        <div class="user-search-left">
          <img class="left-img" src="../assets/images/today-search.png" alt />
        </div>
        <div class="user-search-center">
          <van-search
            class="top-search"
            v-model="searchValue"
            shape="round"
            clearable
            left-icon
            background="none"
            placeholder="请输入客户号/客户名称"
            @search="
              pageNo = 0;
              userList = [];
              finished = false;
              searchHandle();
            "
          />
        </div>
        <div class="user-search-right">
          <img
            class="right-img"
            src="../assets/images/search.png"
            alt
            @click="
              pageNo = 0;
              userList = [];
              finished = false;
              searchHandle();
            "
          />
        </div>
      </div>
      <div class="tab-box">
        <van-tabs
          v-model="activeName"
          animated
          type="line"
          swipe-threshold="3"
          @click="handleClick"
        >
          <van-tab
            v-for="(item, index) in userTypeList"
            :title="item.userTypeName"
            :key="index"
          ></van-tab>
        </van-tabs>
      </div>
      <div class="user-list-box">
        <div class="list-box" v-if="inquriyShowFlag">
          <div class="list-title" v-if="!noData">
            <div class="list-title-custNo">客户号</div>
            <div class="list-title-cshNo">DBU区域</div>
            <div class="list-title-customer">客户名称</div>
            <div class="list-title-lastOrderNoDate">订单号<br />最后下单日</div>
          </div>
          <van-list
            class="list-ul"
            finished-text="没有更多了"
            :finished="finished"
            v-model="loading"
            v-if="!noData"
            offset="10"
            @load="searchHandle()"
          >
            <li
              class="list-li"
              v-for="(item, index) in userList"
              :key="index"
              @click="clickToPageDetail(item.userCode)"
            >
              <div
                class="list-content"
                style="width: 25%; padding: 0px 5px 0px 0px"
                v-text="item.userCode"
              ></div>
              <div
                class="list-content"
                style="width: 15%; padding: 0px 5px 0px 0px"
                v-if="item.cshId"
                v-text="item.cshName"
              ></div>
              <div
                class="list-content"
                style="width: 15%; padding: 0px 5px 0px 5px"
                v-else
              >
                -
              </div>
              <div
                class="list-content"
                style="width: 28%; padding: 0px 5px 0px 5px"
                v-if="item.displayName"
                v-text="item.displayName"
              ></div>
              <div
                class="list-content"
                style="width: 28%; padding: 0px 5px 0px 5px"
                v-else
              >
                -
              </div>
              <div style="width: 32%" v-if="item.codeno">
                <div class="list-content" v-text="item.codeno"></div>
                <div class="list-content" v-text="item.orderDateMax"></div>
              </div>
              <div
                class="list-content"
                style="
                  width: 32%;
                  padding: 0px 10px 0px 0px;
                  text-align: center;
                "
                v-else
              >
                -
              </div>
            </li>
          </van-list>
        </div>
      </div>
    </div>
    <van-popup v-model="cshShow" position="bottom" :overlay="true">
      <van-picker
        show-toolbar
        :columns="cshList"
        :default-index="0"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script src="path/tojquery.flip.js"></script>
<script>
import $ from "jquery";
import echarts from "echarts";
import { getCshlist, getUserData, getUserList } from "@/api/userCenter";
import { STATUS_CODE_OK } from "@/config";
import store from "@/store";
import { mapActions } from "vuex";
import countTo from "vue-count-to";
import Header from "@/components/Header";
export default {
  name: "userCenter",
  data() {
    return {
      //头部数据
      memeberCreate: "",
      memberTotal: "",
      memberBuy: "",
      //非个人-个人开关按钮
      showPersonalFlg: false,
      //CSH查询
      cshNo: "",
      orderCsh: "",
      userCode: "",
      cshShow: false,
      cshList: [],
      //E-chart图表
      monthXdata: [], // X轴
      monthLeftYdata: [], //新增客户数量 左Y轴
      monthRightYdata: [], //下单客户数量 右Y轴
      //订单查询
      searchValue: "",
      pageNo: 0,
      displayCount: 10,
      inquriyShowFlag: true,
      loading: false,
      finished: false,
      refreshing: false,
      noData: false,
      activeName: 1,
      userList: [], //用户一览 List
      echartsWidth: 0,
      userType: "A", //用户类型
      userTypeList: [
        {
          userTypeName: "全部",
        },
        {
          userTypeName: "经销商用户",
        },
        {
          userTypeName: "街边店(专用)",
        },
        {
          userTypeName: "街边店(公共)",
        },
        {
          userTypeName: "个人用户",
        },
      ], // 用户类型List
    };
  },
  mounted() {
    this.echartsWidth = $(document.body).width() - 30;
    this.echartsWidth = this.echartsWidth + "px";
    $(".user-chart").css("width", this.echartsWidth);
    //获取全局usercode
    this.userCode = store.getters.userCode;
    //初期获取CSH列表数据
    this.getCsh();
    //用户详情页面返回获取显示个人用户筛选
    if (store.getters.showPersonalFlg) {
      this.showPersonalFlg = store.getters.showPersonalFlg;
    }
    //订单详情页面返回获取CSH
    if (store.getters.cshPicker) {
      this.cshNo = store.getters.cshPicker.value;
      this.orderCsh = store.getters.cshPicker.text;
    }
    //用户详情页面返回获取用户类型筛选
    if (store.getters.userType) {
      this.userType = store.getters.userType;
    }
    //用户详情页面返回获取用户类型筛选Index
    if (store.getters.userTypeIndex) {
      this.activeName = store.getters.userTypeIndex;
    }
    //初期获取头部/E-chart图表数据
    this.getInfo(this.cshNo);
  },
  methods: {
    //获取CSH列表数据
    async getCsh() {
      let { data } = await getCshlist({
        userCode: this.userCode,
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        for (var i = 0; i < data.cshOrderStsInfoVo.userCshListVo.length; i++) {
          if (data.cshOrderStsInfoVo.userCshListVo.length > 1) {
            if (i == 0) {
              var cshItem0 = {
                value: "",
                text: "",
              };
              cshItem0.value = "";
              cshItem0.text = "全部";
              this.cshList.push(cshItem0);
            }
          }
          var cshItem = {
            value: "",
            text: "",
          };
          cshItem.value = data.cshOrderStsInfoVo.userCshListVo[i].cshId;
          cshItem.text = data.cshOrderStsInfoVo.userCshListVo[i].cshName;
          this.cshList.push(cshItem);
        }
      }
    },

    //选择是否包含 个人-非个人
    userTypeSelect() {
      //把显示个人用户设定到localStorage
      this.setShowPersonal(this.showPersonalFlg);
      this.getInfo(this.showPersonalFlg);
    },
    //选择 CSH 列表
    searchCsh() {
      this.cshShow = true;
    },
    //选择 CSH 列表-取消
    onCancel() {
      this.cshShow = false;
    },
    //选择 CSH 列表-确认
    onConfirm(picker) {
      this.cshShow = false; //确认后关闭底部弹框FLG
      this.cshNo = picker.value; // cshCode
      this.orderCsh = picker.text; // csh名称
      //把选中CSH设定到localStorage
      this.setCshPicker(picker);
      //切换确认CSH 获取对应CSH的Header部数据/E-chart展示数据
      this.getInfo(this.cshNo);
      //切换确认CSH 获取对应CSH的订单列表展示数据
      this.pageNo = 0;
      this.userList = [];
      this.finished = false;
      this.searchHandle();
    },

    //点击 订单状态 筛选
    handleClick(name) {
      if (name == 0) {
        this.userType = ""; //全部用户
      } else if (name == 1) {
        this.userType = "A"; //经销商用户
      } else if (name == 2) {
        this.userType = "B"; //街边店(专用)用户
      } else if (name == 3) {
        this.userType = "C"; //街边店(公用)用户
      } else if (name == 4) {
        this.userType = "D"; //个人用户
      }
      this.setUserType(this.userType);
      this.setUserTypeIndex(name);
      this.pageNo = 0;
      this.userList = [];
      this.finished = false;
      this.searchHandle(this.userType);
    },

    //获取Header部/E-chart展示数据
    async getInfo() {
      //jQuery日历卡片自动翻牌特效
      $(function () {
        flip();
      });
      function flip() {
        var timer = null;
        var i = 0;
        var j = 0;
        var aFlip = $(".container");
        function flipFn(arg1, arg2) {
          aFlip.eq(i).toggleClass("card-flipped");
          i++;
          if (i < 1) {
            i = 0;
          } //i<1 初期只翻转一次结束自动翻转
        }
        timer = setInterval(flipFn, 500); //控制翻转时间
      }

      // 新增客户数量-下单用户数量 E-hart图表
      this.userChart1 = echarts.init(this.$refs.userChart1);
      this.userChart1.setOption({
        grid: {
          left: "15%",
          right: "15%",
          bottom: "10%",
        },
        legend: {
          data: ["新增客户", "下单客户"],
          inactiveColor: "#999",
          x: "center",
          y: "top",
          itemWidth: 25,
          itemHeight: 10,
          padding: [15, 0, 0, 0],
          textStyle: {
            fontSize: 10,
          },
          itemGap: 12,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
              show: false,
            },
          },
          confine: true,
          extraCssText: "font-size: 12px; text-align: left;",
          position: function (point, params, dom, rect, size) {
          // position: function (point, params, dom) {
            dom.style.transform = "translateZ(0)";
          },
          formatter: function (params) {
            console.log(params);
            var tooltipData = "";
            var tooltipData1 = "";
            var datalength = params[0]["data"].allCsh.length;
            var dotHtml =
              '<span style="display:inline-block;margin:0px 5px 0px 10px;border-radius:5px;width:5px;height:5px;background-color:#eeeeee"></span>';
            for (var i = 0; i < datalength; i += 2) {
              if (params[0]["data"].allCsh[i]) {
                tooltipData1 +=
                  dotHtml +
                  params[0]["data"].allCsh[i].name +
                  " ：" +
                  params[0]["data"].allCsh[i].value +
                  " / " +
                  params[1]["data"].allCsh[i].value;
              }
              if (params[0]["data"].allCsh[i + 1]) {
                tooltipData1 +=
                  dotHtml +
                  params[0]["data"].allCsh[i + 1].name +
                  " ：" +
                  params[0]["data"].allCsh[i + 1].value +
                  " / " +
                  params[1]["data"].allCsh[i + 1].value +
                  "</br>";
              }
            }
            if (datalength > 0) {
              return (tooltipData =
                "<新增客户 / 下单用户>" +
                "</br>" +
                dotHtml +
                params[0]["data"].name +
                " : " +
                params[0]["data"].value +
                " / " +
                params[1]["data"].value +
                "</br>" +
                tooltipData1);
            } else {
              return (
                "<新增客户 / 下单用户>" +
                "</br>" +
                dotHtml +
                params[0]["data"].name +
                " : " +
                params[0]["data"].value +
                " / " +
                params[1]["data"].value
              );
            }
          },
        },
        xAxis: [
          {
            type: "category",
            data: this.monthXdata,
            axisLine: {
              show: true, //x轴
            },
            axisTick: {
              show: false, //x轴刻度线
            },
            axisLabel: {
              showMaxLabel: true, //显示最大刻度值
              interval: 0,
              rotate: 30,
              fontSize: 10,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "新增客户",
            nameTextStyle: {
              color: "#000",
              fontSize: "12",
              fontFamily: "Helvetica",
              padding: [0, 15, 5, 20],
            },
            position: "left",
            axisLine: {
              show: true, //y轴
            },
            axisTick: {
              show: true, //y轴刻度线
            },
            splitLine: {
              show: false, //y轴网格线
            },
          },
          {
            type: "value",
            name: "下单客户",
            nameTextStyle: {
              color: "#000",
              fontSize: "12",
              fontFamily: "Helvetica",
              padding: [0, 5, 5, 0],
            },
            position: "right",
            axisLine: {
              show: true, //y轴
            },
            axisTick: {
              show: true, //y轴刻度线
            },
            splitLine: {
              show: false, //y轴网格线
            },
          },
        ],
        series: [
          {
            name: "新增客户",
            type: "line",
            data: this.monthLeftYdata,
            // symbol: "none", //去掉折线图中的节点
            smooth: true, //true 为平滑曲线，false为直线
            color: "#DEB248",
          },
          {
            name: "下单客户",
            type: "bar",
            yAxisIndex: 1,
            data: this.monthRightYdata,
            barWidth: "50%", //柱图宽度
            itemStyle: {
              barBorderRadius: [5, 5, 0, 0],
              borderWidth: "10",
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#da291c" },
                { offset: 1, color: "#eeeeee" },
                { offset: 1, color: "#dcdcdc" },
              ]),
            },
          },
        ],
      });

      //调用后台获取数据
      let { data } = await getUserData({
        userCode: this.userCode,
        cshCode: this.cshNo,
        showPersonalFlg: this.showPersonalFlg,
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        //Header部数据
        this.memeberCreate = data.memberCenterInfoVo.memberCreateCount; //新增客户数量(当月)
        this.memberTotal = data.memberCenterInfoVo.memberTotalCount; //用户总量
        this.memberBuy = data.memberCenterInfoVo.memberTodayBuy; //下单客户数量(当月)
        this.monthXdata =
          data.memberCenterInfoVo.memeberCreateCountData.monthScaleData;
        //新增客户数量 左Y轴数据取得
        this.monthLeftYdata =
          data.memberCenterInfoVo.memeberCreateCountData.data;
        //下单客户数量 右Y轴数据取得
        this.monthRightYdata = data.memberCenterInfoVo.memberBuyCountData.data;

        // 交易金额E-hart图表填充
        this.userChart1.setOption({
          xAxis: [
            {
              data: this.monthXdata,
            },
          ],
          series: [
            {
              data: this.monthLeftYdata,
            },
            {
              data: this.monthRightYdata,
            },
          ],
        });
      }
    },
    // 初期展示全国CSH客户/客户查询/滑动查询
    async searchHandle() {
      this.pageNo = this.pageNo + 1;
      let { data } = await getUserList({
        userCode: this.userCode,
        cshCode: this.cshNo,
        pageNo: this.pageNo,
        displayCount: this.displayCount,
        searchComment: this.searchValue,
        userType: this.userType,
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        if (data.userListVoList && data.userListVoList.length < 1) {
          this.finished = true;
          this.loading = false;
        } else {
          for (var i = 0; i < data.userListVoList.length; i++) {
            this.userList.push(data.userListVoList[i]);
          }
        }
        if (data.userListVoList.length < this.displayCount) {
          this.finished = true;
        }
      } else {
        this.finished = true;
      }
      this.loading = false;
    },

    //点击客户List数据跳转用户详情页面
    clickToPageDetail(userCode) {
      this.$router.push({
        name: "userCenterDetail",
        params: {
          userCode: userCode,
        },
      });
    },
    ...mapActions([
      "setCshPicker",
      "setUserType",
      "setUserTypeIndex",
      "setShowPersonal",
    ]),
  },
  components: {
    Header,
    countTo,
  },
};
</script>
<style lang="scss" scoped>
.box {
  height: 100%;
  .header-info {
    display: flex;
    .header-info-box {
      display: flex;
      height: 115px;
      border-radius: 20px;
      width: 71%;
      margin-right: 10px;
      .header-info-detail {
        width: 100%;
        margin: 20px 0px;
        color: #000;
        border-right: 1px solid #dcdcdc;
        .header-info-title {
          font-size: 14px;
          font-weight: bold;
        }
        .header-info-unit {
          font-size: 10px;
          padding-bottom: 10px;
        }
        .header-info-content {
          font-size: 18px;
        }
      }
    }
    .header-date-box {
      height: 115px;
      width: 22%;
      .container {
        flex-grow: 1;
        flex-basis: 0;
        display: flex;
        flex-direction: column;
        position: relative;
      }
      .re-box {
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 1s ease;
        -webkit-transition: all 1s ease;
      }
      .re-item {
        position: relative;
        perspective: 1000;
        -webkit-perspective: 1000;
        perspective: 1000;
        -webkit-perspective: 1000;
      }
      .re-item img {
        width: 75px;
        margin: 5px 20px 20px 10px;
      }
      .re-item-front,
      .re-item-back {
        left: 0;
        top: 55px;
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
        -ms-backface-visibility: hidden;
        -moz-backface-visibility: hidden;
        -o-backface-visibility: hidden;
        overflow: hidden;
        transition: all 1.5s ease;
        -webkit-transition: all 1.5s ease;
        -moz-transition: all 1.5s ease;
        -ms-transition: all 1.5s ease;
        -o-transition: all 1.5s ease;
      }
      .re-item-front {
        position: absolute;
        transform: rotateY(0deg);
        -webkit-transform: rotateY(0deg);
      }
      .re-item-back {
        position: relative;
        transform: rotateY(-180deg);
        -webkit-transform: rotateY(-180deg);
      }
      .card-flipped .re-item-back {
        transform: rotateY(-360deg);
        -webkit-transform: rotateY(-360deg);
      }
      .card-flipped .re-item-front {
        transform: rotateY(-180deg);
        -webkit-transform: rotateY(-180deg);
      }
    }
  }
  .orderCsh-box {
    display: flex;
    height: 35px;
    margin: 0px 0px 5px 0px;
    align-items: center;
    justify-items: center;
    .userTypeBox {
      padding: 0px 5px 0px 0px;
      width: 75%;
      display: flex;
      justify-content: flex-end;
      .userTypeChoose {
        padding: 0px 5px 0px 0px;
        font-size: 12px;
        line-height: 16px;
      }
    }
    .csh-box {
      width: 25%;
      padding: 0px;
      background: unset;
      /deep/ .van-field__control {
        text-align: right;
        font-size: 12px;
      }
    }
  }
  .echart-box {
    width: 100%;
    height: 330px;
    border-radius: 20px;
    .user-chart {
      padding: 5px;
      height: 330px;
    }
  }
  .user-search-box {
    display: flex;
    align-items: center;
    width: 100%;
    padding-top: 10px;
    .user-search-left {
      padding: 0px 10px 0px 0px;
      .left-img {
        width: 60px;
        height: 60px;
      }
    }
    .user-search-center {
      padding: 0px 10px 0px 0px;
      width: -webkit-fill-available;
      .top-search {
        padding: 0px;
        .van-cell {
          padding: 0px 10px 0px 0px;
        }
        /deep/ .van-field__control {
          padding: 0px 15px;
        }
      }
    }
    .user-search-right {
      padding: 10px 0px 0px 0px;
      .right-img {
        width: 50px;
        height: 50px;
      }
    }
  }
  .tab-box {
    padding-bottom: 15px;
  }

  .user-list-box {
    .list-box {
      height: 100%;
      margin-top: 0px;
      .list-title {
        display: flex;
        height: 40px;
        background: #999;
        border-radius: 20px 20px 0px 0px;
        padding: 0px 10px;
        align-items: center;
        text-align: left;
        font-size: 14px;
        color: #000;
        .list-title-custNo {
          width: 20%;
          padding-left: 5px;
        }
        .list-title-cshNo {
          width: 22%;
        }
        .list-title-customer {
          width: 28%;
        }
        .list-title-lastOrderNoDate {
          width: 30%;
          text-align: center;
        }
      }
      .list-ul {
        border-radius: 0px 0px 20px 20px;
        margin-bottom: 20px;
        .list-li {
          display: flex;
          height: 50px;
          border-bottom: 1px solid #dcdcdc;
          align-items: center;
          text-align: left;
          margin: 0px 3px 0px 3px;
        }
        .list-content {
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          padding-right: 3px;
        }
      }
    }
  }
  /deep/ .van-picker__cancel,
  /deep/ .van-picker__confirm {
    font-size: 18px;
  }
}
</style>